import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    initUrgencyTimer();

    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
// === Refresh cart drawer section after add-to-cart ===
(function(){
  const ROOT = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
  const SECTIONS = ['cart-drawer-host'];

  async function refreshDrawer() {
    try {
      const res = await fetch(`${ROOT}?sections=${SECTIONS.join(',')}`, {
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      const json = await res.json();

      if (json['cart-drawer-host']) {
        const parser = new DOMParser();
        const html = parser.parseFromString(json['cart-drawer-host'], 'text/html');
        const newDrawer = html.querySelector('cart-drawer-component');
        const liveDrawer = document.querySelector('cart-drawer-component');
        if (newDrawer && liveDrawer) {
          liveDrawer.innerHTML = newDrawer.innerHTML;
        }
      }

      // Force drawer open
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      document.body.classList.add('js-drawer-open', 'cart-drawer-open');

      // Fire events for other scripts
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch(e) {
      console.error('Cart drawer refresh failed', e);
    }
  }

  // Listen for AI block or any cart:add event
  document.addEventListener('cart:add', refreshDrawer);
})();
function initUrgencyTimer() {
  const timer = document.getElementById('urgency-timer');
  if (!timer || timer.dataset.running) return;

  timer.dataset.running = 'true';

  const minutes = Number(timer.dataset.durationMinutes || 5);
  const total = minutes * 60 * 1000;

  let end = sessionStorage.getItem('urgency_end');
  if (!end) {
    end = Date.now() + total;
    sessionStorage.setItem('urgency_end', end);
  }

  const value = timer.querySelector('#urgency-countdown');
  const bar = timer.querySelector('#urgency-fill');

  setInterval(() => {
    const remaining = Math.max(0, end - Date.now());
    const m = Math.floor(remaining / 60000);
    const s = Math.floor((remaining % 60000) / 1000);
    value.textContent = `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    bar.style.width = `${(remaining / total) * 100}%`;
  }, 1000);
}

